import {apiUrl} from "./api_url";

export async function updateTakeProfit(amount) {
    try {
        const response = await fetch(`${apiUrl}/take_profit`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({amount})
        });

        const data = await response.json();

        if (response.ok) {
            return data.message;
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getTakeProfit() {
    try {
        const response = await fetch(`${apiUrl}/take_profit/current`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = await response.json();

        if (response.ok) {
            return data;
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}
